import { render, staticRenderFns } from "./CreateClientForm.vue?vue&type=template&id=b29b2bd4"
import script from "./CreateClientForm.vue?vue&type=script&lang=js"
export * from "./CreateClientForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports